import { z } from 'zod';
import { FromSchema, EnumSchema } from '@40seas/entities/common';
import { Recipient } from '@40seas/entities/notifications';
import { BaseEntity, BaseEntitySchema } from '@40seas/models';
import { UserRole } from '@40seas/entities/users';

export const SendEmailSchema = z.object({
    eventType: z.string(),
    recipientEmails: z.array(
        z.object({
            email: z.string().email({
                message: 'Invalid email address',
            }),
            name: z.string().optional(),
        }),
    ),
    emailParams: z.any(),
    role: EnumSchema(UserRole).optional(),
    entity: BaseEntitySchema.or(z.any()).optional(),
});

export class SendEmailDto extends FromSchema(SendEmailSchema) {
    eventType: string;
    recipientEmails: Recipient[];
    emailParams: { receiverEmail: string; [key: string]: any };
    role?: UserRole;
    entity?: BaseEntity;
}
